// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and base styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Arial', sans-serif;
  background-color: #f8f9fa;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation styles */
.navbar {
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  padding: 1rem 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: sticky;
  top: 0;
  z-index: 1000;
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-logo h2 {
  color: white;
  font-size: 24px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
}

.nav-item {
  margin: 0;
}

.nav-link {
  color: white;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 6px;
  transition: all 0.3s ease;
  font-size: 16px;
}

.nav-link:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateY(-2px);
}

/* Main content */
.main-content {
  flex: 1 1;
  padding: 20px;
}

/* Home page styles */
.home-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
}

.home-content {
  text-align: center;
}

.home-content h1 {
  font-size: 48px;
  color: #1e3c72;
  margin-bottom: 20px;
  font-weight: bold;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
}

.home-content > p {
  font-size: 20px;
  color: #6c757d;
  margin-bottom: 40px;
  font-weight: 500;
}

.feature-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 30px;
  margin-top: 40px;
}

.feature-card {
  background: white;
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  border-color: #2c5aa0;
}

.feature-card h3 {
  font-size: 24px;
  color: #1e3c72;
  margin-bottom: 15px;
  font-weight: bold;
}

.feature-card p {
  color: #6c757d;
  margin-bottom: 20px;
  line-height: 1.6;
}

.feature-link {
  display: inline-block;
  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);
  color: white;
  text-decoration: none;
  padding: 12px 24px;
  border-radius: 6px;
  font-weight: bold;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.feature-link:hover {
  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);
}

/* Responsive design */
@media (max-width: 768px) {
  .nav-container {
    flex-direction: column;
    gap: 1rem;
  }
  
  .nav-menu {
    gap: 1rem;
  }
  
  .home-content h1 {
    font-size: 32px;
  }
  
  .home-content > p {
    font-size: 16px;
  }
  
  .feature-cards {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .feature-card {
    padding: 20px;
  }
}

@media (max-width: 480px) {
  .nav-menu {
    flex-direction: column;
    gap: 0.5rem;
  }
  
  .home-content h1 {
    font-size: 28px;
  }
  
  .feature-card h3 {
    font-size: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,eAAe;EACf,wCAAwC;EACxC,gBAAgB;EAChB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;AACf;;AAEA,qBAAqB;AACrB;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Reset and base styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Arial', sans-serif;\n  background-color: #f8f9fa;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Navigation styles */\n.navbar {\n  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);\n  padding: 1rem 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n}\n\n.nav-container {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.nav-logo h2 {\n  color: white;\n  font-size: 24px;\n  font-weight: bold;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.nav-menu {\n  display: flex;\n  list-style: none;\n  gap: 2rem;\n}\n\n.nav-item {\n  margin: 0;\n}\n\n.nav-link {\n  color: white;\n  text-decoration: none;\n  font-weight: 500;\n  padding: 0.5rem 1rem;\n  border-radius: 6px;\n  transition: all 0.3s ease;\n  font-size: 16px;\n}\n\n.nav-link:hover {\n  background: rgba(255, 255, 255, 0.1);\n  transform: translateY(-2px);\n}\n\n/* Main content */\n.main-content {\n  flex: 1;\n  padding: 20px;\n}\n\n/* Home page styles */\n.home-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 40px 20px;\n}\n\n.home-content {\n  text-align: center;\n}\n\n.home-content h1 {\n  font-size: 48px;\n  color: #1e3c72;\n  margin-bottom: 20px;\n  font-weight: bold;\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.home-content > p {\n  font-size: 20px;\n  color: #6c757d;\n  margin-bottom: 40px;\n  font-weight: 500;\n}\n\n.feature-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 30px;\n  margin-top: 40px;\n}\n\n.feature-card {\n  background: white;\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\n  border-color: #2c5aa0;\n}\n\n.feature-card h3 {\n  font-size: 24px;\n  color: #1e3c72;\n  margin-bottom: 15px;\n  font-weight: bold;\n}\n\n.feature-card p {\n  color: #6c757d;\n  margin-bottom: 20px;\n  line-height: 1.6;\n}\n\n.feature-link {\n  display: inline-block;\n  background: linear-gradient(135deg, #28a745 0%, #20c997 100%);\n  color: white;\n  text-decoration: none;\n  padding: 12px 24px;\n  border-radius: 6px;\n  font-weight: bold;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.feature-link:hover {\n  background: linear-gradient(135deg, #218838 0%, #1ea085 100%);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3);\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .nav-container {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  \n  .nav-menu {\n    gap: 1rem;\n  }\n  \n  .home-content h1 {\n    font-size: 32px;\n  }\n  \n  .home-content > p {\n    font-size: 16px;\n  }\n  \n  .feature-cards {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  \n  .feature-card {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .nav-menu {\n    flex-direction: column;\n    gap: 0.5rem;\n  }\n  \n  .home-content h1 {\n    font-size: 28px;\n  }\n  \n  .feature-card h3 {\n    font-size: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
